<template>
  <div class="news-sidebar">
    <div class="row results-info-row">
      <p class="results-info-p">
        <span class="results-count">
          {{ resultCount }}
        </span>
        <span class="text-results"> resultaten</span>
      </p>
    </div>
    <div class="filter-box">
      <div class="row justify-between">
        <span class="org-heading">Publicatiedatum</span>
        <i class="las la-2x la-times-circle clear-icon" @click="resetDate()">
          <q-tooltip> Filter leegmaken </q-tooltip></i
        >
      </div>
      <q-input
        class="budget-input"
        bg-color="white"
        v-model="daysRangeModel"
        outlined
        dense
        @click="$refs.qDateProxy.show()"
        :update="updateRange()"
      >
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer datepicker-icon">
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date range v-model="days" mask="DD-MM-YYYY">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Sluiten" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>

    <div class="filter-box">
      <default-tree
        class="sidebar-margin item-width"
        :nodesState="audienceNodes.options"
        :heading="audienceNodes.label"
        :filtering="true"
        :news="'news'"
        :key="'1'"
      />
    </div>
    <div class="filter-box">
      <default-tree
        class="sidebar-margin item-width"
        :nodesState="purposesNodes.options"
        :heading="purposesNodes.label"
        :news="'news'"
        :filtering="true"
        :key="'3'"
      />
    </div>

    <div class="filter-box sidebar-margin orgs-box" v-if="!hideLocations">
      <span class="org-heading">Locatie</span>
      <div class="row start orgs-select">
        <q-select
          dense
          outlined
          bg-color="white"
          v-model="selectedLocations"
          multiple
          :options="filterLocationsTags"
          option-value="label"
          class="budget-input"
          option-label="label"
          placeholder="Zoek een locatie gemeente of provincie"
          use-input
          input-debounce="0"
          behavior="menu"
          use-chips
          @filter="filterLocationsFn"
          clearable
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
    </div>

    <div class="filter-box">
      <default-tree
        class="sidebar-margin"
        :nodesState="schemeTypesNodes.options"
        :heading="schemeTypesNodes.label"
        :news="'news'"
        :key="'4'"
        :filtering="true"
      />
    </div>
    
    <!-- <div class="filter-box">
      <default-tree
        class="sidebar-margin"
        :nodesState="projectTypesNodes.options"
        :heading="projectTypesNodes.label"
        :news="'news'"
        :key="'5'"
        :filtering="true"
      />
    </div> -->

    <div class="filter-box orgs-box">
      <span class="org-heading">Verstrekker(s)</span>
      <div class="row start orgs-select">
        <q-select
          dense
          outlined
          bg-color="white"
          v-model="organisationsInclude"
          multiple
          :options="filterOrganisationsInclude"
          use-chips
          option-value="name"
          class="budget-input"
          option-label="name"
          label="Zoek alleen in"
          use-input
          input-debounce="0"
          behavior="menu"
          @filter="filterOrganisationsIncludeFn"
          clearable
        />
      </div>

      <div class="row start orgs-select">
        <q-select
          dense
          outlined
          bg-color="white"
          v-model="organisationsExclude"
          multiple
          :options="filterOrganisationsExclude"
          use-chips
          option-value="name"
          class="budget-input mt-20"
          option-label="name"
          label="Zoek niet in"
          use-input
          input-debounce="0"
          behavior="menu"
          @filter="filterOrganisationsExcludeFn"
          clearable
        />
      </div>
    </div>

    <!-- This is just hidden for now, don't remove it: -->
    <!-- <div class="filter-box">
      <default-tree
        class="sidebar-margin"
        :nodesState="industriesNodes.options"
        :heading="industriesNodes.label"
        :news="'news'"
        :key="'2'"
      />
    </div> -->
  </div>
</template>

<script>
import store from '../../store/index';
import { computed, onMounted, ref, watch } from 'vue';
import DefaultTree from '../search-components/DefaultTree.vue';
import OrganisationsService from '../../services/organisations.service';
import NewsUtils from '../../utils/news';
import FiltersService from '../../services/filters.service';

export default {
  components: {
    DefaultTree,
  },
  setup() {
    const resultCount = computed({
      get: () => store.state.newsSearch.resultsCount,
    });

    onMounted(() => {
      FiltersService.getDefaultFilters();
      OrganisationsService.getAllOrganisationsWithBasicInfo();
    });

    const audienceNodes = computed({
      get: () => store.state.advancedSearch.audience,
    });

    //This is just hidden for now, don't remove it:
    /*
    const industriesNodes = computed({
      get: () => store.state.advancedSearch.industries,
    });
    */

    const locationsNodes = computed({
      get: () => store.state.advancedSearch.locations,
    });
    const purposesNodes = computed({
      get: () => store.state.advancedSearch.purposes,
    });

    const schemeTypesNodes = computed({
      get: () => store.state.advancedSearch.schemeTypes,
    });
    
    const projectTypesNodes = computed({
      get: () => store.state.advancedSearch.projectTypes,
    });

    const allOrganisations = computed({
      get: () => store.state.organisations.organisationsWithBasicInfo,
    });

    const organisationsInclude = computed({
      get: () => store.state.newsSearch.organisationsInclude,
      set: (val) => store.commit('newsSearch/updateOrganisationsInclude', val),
    });

    const organisationsExclude = computed({
      get: () => store.state.newsSearch.organisationsExclude,
      set: (val) => store.commit('newsSearch/updateOrganisationsExclude', val),
    });

    const selectedLocations = computed({
      get: () => store.state.newsSearch.locationsSelectArray,
      set: (value) => {
        store.commit('newsSearch/updateSelectedLocations', value);
      },
    });

    const locationsOptions = computed({
      get: () => store.state.advancedSearch.locationsOptions,
    });

    const filterLocationsTags = ref(locationsOptions.value);
    const filterOrganisationsInclude = ref(allOrganisations.value);
    const filterOrganisationsExclude = ref(allOrganisations.value);

    const days = computed({
      get: () => store.state.newsSearch.daysRange,
      set: (val) => {
        store.commit('newsSearch/updateDaysRange', val);
      },
    });

    watch(selectedLocations, () => {
      if (selectedLocations.value == null) {
        store.commit('newsSearch/updateSelectedLocations', null);
      }
      NewsUtils.searchNews(isTableView.value);
    });

    watch(organisationsExclude, () => {
      if (organisationsExclude.value == null) {
        store.commit('newsSearch/updateOrganisationsExclude', []);
      }
      NewsUtils.searchNews(isTableView.value);
    });

    watch(organisationsInclude, () => {
      if (organisationsInclude.value == null) {
        store.commit('newsSearch/updateOrganisationsInclude', []);
      }
      NewsUtils.searchNews(isTableView.value);
    });

    const resetDate = () => {
      store.commit('newsSearch/updateDaysRange', { from: '', to: '' });
      NewsUtils.searchNews(isTableView.value);
    };

    const dateFrom = computed({
      get: () => store.state.newsSearch.daysRange.from,
    });

    const dateTo = computed({
      get: () => store.state.newsSearch.daysRange.to,
    });

    watch(dateFrom, () => {
      NewsUtils.searchNews(isTableView.value);
    });

    const daysRangeModel = ref(null);

    const updateRange = () => {
      daysRangeModel.value = [dateFrom.value, dateTo.value].join(' - ');
    };

    const isTableView = computed({
      get: () => store.state.newsSearch.isTableView,
    });

    const hideLocations = store.state.advancedSearch.locationsOptions.length < 4;
    return {
      hideLocations,
      isTableView,
      daysRangeModel,
      updateRange,
      resetDate,
      days,
      filterOrganisationsExclude,
      filterOrganisationsInclude,
      locationsOptions,
      filterLocationsTags,
      dateFrom,
      dateTo,
      allOrganisations,
      organisationsInclude,
      organisationsExclude,
      audienceNodes,
      //This is just hidden for now, don't remove it:
      //industriesNodes,
      locationsNodes,
      purposesNodes,
      resultCount,
      schemeTypesNodes,
      projectTypesNodes,
      selectedLocations,
      filterLocationsFn(val, update) {
        update(() => {
          if (val === '') {
            filterLocationsTags.value = locationsOptions.value;
          } else {
            const needle = val.toLowerCase();

            filterLocationsTags.value = locationsOptions.value.filter(
              (v) => v.label.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },
      filterOrganisationsIncludeFn(val, update) {
        update(() => {
          if (val === '') {
            filterOrganisationsInclude.value = allOrganisations.value;
          } else {
            const needle = val.toLowerCase();

            filterOrganisationsInclude.value = allOrganisations.value.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },

      filterOrganisationsExcludeFn(val, update) {
        update(() => {
          if (val === '') {
            filterOrganisationsExclude.value = allOrganisations.value;
          } else {
            const needle = val.toLowerCase();

            filterOrganisationsExclude.value = allOrganisations.value.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },
    };
  },
};
</script>
